"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeLogin = void 0;
var TypeLogin;

(function (TypeLogin) {
  /**
   * 네이티브 로그인 모달을 열어요
   */
  TypeLogin["ReqLoginOpen"] = "REQ.LOGIN.OPEN";
})(TypeLogin = exports.TypeLogin || (exports.TypeLogin = {}));